import React from 'react';
import { withTheme } from 'styled-components';
import MUISnackbar from 'material-ui/Snackbar';

type Props = {
  onClose: () => void,
  message: string,
  type: MessageType,
  visible: boolean,
  theme: Object,
};
type MessageType = 'error' | 'warning' | 'message';

function Snackbar({ message, visible, type, onClose, theme }: Props) {
  const errorStyle = {
    textAlign: 'center',
    backgroundColor: theme.colors.delete,
  };

  const warningStyle = {
    textAlign: 'center',
    backgroundColor: theme.colors.warning,
  };

  const messageStyle = {
    textAlign: 'center',
    backgroundColor: theme.colors.primary,
  };

  const getBodyStyle = (messageType: MessageType) => {
    switch (messageType) {
      case 'error':
        return errorStyle;
      case 'warning':
        return warningStyle;
      case 'message':
      default:
        return messageStyle;
    }
  };

  return (
    <MUISnackbar
      bodyStyle={getBodyStyle(type)}
      open={visible}
      message={message}
      onActionClick={onClose}
      onRequestClose={onClose}
      autoHideDuration={3000}
    />
  );
}

export default withTheme(Snackbar);



// WEBPACK FOOTER //
// ./src/common/modules/ui/components/Snackbar.js